const CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

const pad = (value: number) => String(value).padStart(2, "0");

// A date answer is a calendar day, not an instant: going through toISOString or
// new Date("YYYY-MM-DD") reads it as UTC midnight and moves it a day outside UTC.
export function toCalendarDate(value: Date | string): string {
  if (typeof value === "string") {
    const match = CALENDAR_DATE.exec(value);
    if (match) return `${match[1]}-${match[2]}-${match[3]}`;
    value = new Date(value);
  }
  if (Number.isNaN(value.getTime())) return "";
  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
}

export function fromCalendarDate(value: string): Date | null {
  const match = CALENDAR_DATE.exec(value);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}
